import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { screenWidthSelector, showNSFWModalSelector, siteInfoSelector } from 'sites/state/modules/common/selectors';
import { setShowNSFWModalAction } from 'sites/state/modules/common/actions';
import VerificationRequiredModal from 'sites/views/age-verification-by-id-v2/verification-required-modal';
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';
import { isOpenAgeVerificationProcessModalSelector, isOpenAgeVerifiedModalSelector } from 'sites/state/modules/age-verification/selectors';
import { setIsOpenAgeVerificationProcessModalAction, setIsOpenAgeVerifiedModalAction } from 'sites/state/modules/age-verification/actions';
import QueryParams from 'sites/utils/QueryParams';
import {
   AGE_VERIFICATION_PROCESS_MODAL_QUERY_PARAM_KEY,
   AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY,
   AGE_VERIFICATION_SUCCESS_MODAL_QUERY_PARAM_KEY,
} from 'sites/views/age-verification-by-id-v2/data';
import CreateEditModal from 'common/components/modules/modal-wrapper';
import AgeVerificationModalWrapper from 'sites/views/age-verification-by-id-v2/age-verification-process-modal-view/modules/modal-wrapper';
import Loader from 'common/components/elements/loader/circle';

const AgeVerificationProcessModalContainer = lazy(() => import('./age-verification-process-modal'));


class AgeVerificationByIdContainer extends Component {
   static propTypes = {
      screenWidth: PropTypes.number,
      siteInfo: PropTypes.object,
      showNSFWModal: PropTypes.bool,
      setShowNSFWModal: PropTypes.func,
      goTo: PropTypes.func,
      isOpenAgeVerificationProcessModal: PropTypes.bool,
      setIsOpenAgeVerificationProcessModal: PropTypes.func,
      isOpenAgeVerifiedModal: PropTypes.bool,
      setIsOpenAgeVerifiedModal: PropTypes.func,
   }

   componentDidMount(){
      const { setIsOpenAgeVerificationProcessModal, setShowNSFWModal, setIsOpenAgeVerifiedModal } = this.props;

      if(Boolean(QueryParams.getParam(AGE_VERIFICATION_PROCESS_MODAL_QUERY_PARAM_KEY))) {
         setIsOpenAgeVerificationProcessModal(true)
      } else if(Boolean(QueryParams.getParam(AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY))) {
         setShowNSFWModal(true)
      }

      if(Boolean(QueryParams.getParam(AGE_VERIFICATION_SUCCESS_MODAL_QUERY_PARAM_KEY))) {
         setIsOpenAgeVerifiedModal(true)
      }
   }

   onClickSignIn = () => {
      const { setShowNSFWModal, goTo } = this.props;
      setShowNSFWModal(false)
      goTo(Router.route('SIGN_IN').getCompiledPath());
   }

   onClickVerifyMyAge = () => {
      const { setShowNSFWModal, setIsOpenAgeVerificationProcessModal } = this.props;
      setShowNSFWModal(false)
      setIsOpenAgeVerificationProcessModal(true)
   }

   onCloseAgeVerificationSuccessModal = () => {
      const { setIsOpenAgeVerifiedModal } = this.props;
      setIsOpenAgeVerifiedModal(false)
      QueryParams.removeQueryParam(AGE_VERIFICATION_SUCCESS_MODAL_QUERY_PARAM_KEY)
   }

   render() {
      const {
         showNSFWModal,
         screenWidth,
         siteInfo,
         isOpenAgeVerificationProcessModal,
         setShowNSFWModal,
         isOpenAgeVerifiedModal,
      } = this.props;
      const isMobile = screenWidth <= 1024;

      const fallbackComponent = (
         <AgeVerificationModalWrapper
            isMobile={ isMobile }
            withoutCloseButton
         >
            <div
               className='w-full h-full flex items-center justify-center'
            >
               <Loader
                  color='primary'
               />
            </div>
         </AgeVerificationModalWrapper>
      )

      return (
         <>
            {
               isOpenAgeVerificationProcessModal && (
                  <Suspense
                     fallback={
                        fallbackComponent
                     }
                  >
                     <AgeVerificationProcessModalContainer />
                  </Suspense>
               )
            }
            {
               showNSFWModal && (
                  <VerificationRequiredModal
                     isMobile={ isMobile }
                     siteInfo={ siteInfo }
                     onClickSignIn={ this.onClickSignIn }
                     onClickVerifyMyAge={ this.onClickVerifyMyAge }
                     onCloseModal={ () => setShowNSFWModal(false) }
                  />
               )
            }
            {
               isOpenAgeVerifiedModal && (
                  <CreateEditModal
                     type='confirm'
                     onCloseModal={ () => this.onCloseAgeVerificationSuccessModal() }
                     isMobile={ isMobile }
                     action={ () => this.onCloseAgeVerificationSuccessModal() }
                     icon='done'
                     iconColor='success'
                     title='Age verified'
                     description='You have successfully passed Age verification'
                     withoutCancelButton
                     buttonText='Enter'
                     buttonClassName='w-full mt-6'
                     confirmButtonProperties={ {
                        backgroundColor: null,
                     } }
                  />
               )
            }
         </>
      )
   }
}

const mapStateToProps = (state) => {
   return {
      screenWidth: screenWidthSelector(state),
      siteInfo: siteInfoSelector(state),
      showNSFWModal: showNSFWModalSelector(state),
      isOpenAgeVerificationProcessModal: isOpenAgeVerificationProcessModalSelector(state),
      isOpenAgeVerifiedModal: isOpenAgeVerifiedModalSelector(state),
   }
}

const mapDispatchToProps = (dispatch) => {
   return {
      setShowNSFWModal: (bool) => dispatch(setShowNSFWModalAction(bool)),
      goTo: (path, search) => {
         dispatch(push({
            pathname: path,
            search,
         }))
      },
      setIsOpenAgeVerificationProcessModal: (bool) => dispatch(setIsOpenAgeVerificationProcessModalAction(bool)),
      setIsOpenAgeVerifiedModal: (bool) => dispatch(setIsOpenAgeVerifiedModalAction(bool)),
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgeVerificationByIdContainer);
